import { MutationTree, ActionTree, GetterTree } from 'vuex';
import { DismissedItemsStoreState } from './interfaces/DismissedItemsStoreState';
import { RootState } from './interfaces/RootState';

export const initialState: DismissedItemsStoreState = {
    itemsDismissedInSession: [],
    itemsDismissedTillDate: {}
};

export const actions: ActionTree<DismissedItemsStoreState, RootState> = {
    async dismissInSession({ state, commit }, id: string) {
        if (!state.itemsDismissedInSession.includes(id))
            commit('setDismissedInSession', id);
    },
    async dismissUntil({ commit }, { id, daysLater }: { id: string, daysLater: number }) {
        const dismissedUntil = new Date();
        dismissedUntil.setDate(dismissedUntil.getDate() + daysLater);
        commit('setDismissedUntil', { id, dismissedUntil } );
    }
};

export const mutations: MutationTree<DismissedItemsStoreState> = {
    setDismissedInSession: (state, id: string) =>
        state.itemsDismissedInSession.push(id),
    setDismissedUntil(state, { id, dismissedUntil }: {id: string, dismissedUntil: Date}) {
        state.itemsDismissedTillDate[id] = dismissedUntil.toString();
    }
};

export const getters: GetterTree<DismissedItemsStoreState, unknown> = {
    isDismissedInSession: (state) => (id: string): boolean => state.itemsDismissedInSession.includes(id),
    getDismissedUntilDate: (state) => (id: string): Date | undefined => {
        const dismissedUntilTimeString = state.itemsDismissedTillDate[id];
        if(dismissedUntilTimeString)
            return new Date(dismissedUntilTimeString);
    },
};

export default {
    namespaced: true,
    state: initialState,
    actions,
    getters,
    mutations
};